export function findNumberOfFeedbacks(data) {
  /** data is in format [ {bId,data},{bId,data}]
   * we need to find lenght of data in all object ie branches
   */

  let numOfBranches = data.length;
  let numOfFeebacks = 0;
  for (let a = 0; a < numOfBranches; a++) {
    numOfFeebacks += data[a].data.length;
  }
  return numOfFeebacks;
}
